import { Component, ViewChild } from '@angular/core';
import {FormControl} from '@angular/forms';
import { NgxLinkifyjsService } from 'ngx-linkifyjs';

import {SlideshowService} from '../slideshow.service';
import {ApiService} from '../../shared/api.service';
import {TeamService} from '../../shared/team.service';
import {UserSettingsService} from '../../shared/user-settings.service';

@Component({
    selector: 'details-component',
    templateUrl: 'details.component.html'
})
export class DetailsComponent {
    userCanEdit = false;
    user;
    teamService = new TeamService();
    minDate = new Date();
    targetDateControl = new FormControl();

    @ViewChild('notes') notes;

    constructor(private linkService: NgxLinkifyjsService, private slideshow: SlideshowService, private api: ApiService, private userSettings: UserSettingsService) {
        let user = api.getProp('user');
        this.user = user;
        if( user.role != 'writer' ) {
            this.userCanEdit = true;
        }
        this.teamService.loadTeam(this.slideshow.assignment);
        if( this.slideshow.assignment.targetPublishDate ) {
            this.targetDateControl.setValue(new Date(this.slideshow.assignment.targetPublishDate));
        }
        this.targetDateControl.valueChanges.subscribe(value => {
            if( value ) {
                this.slideshow.assignment.targetPublishDate = this.slideshow.getDate(new Date(value));
            } else {
                this.slideshow.assignment.targetPublishDate = '';
            }
        });
        this.slideshow.targetPublishDateChange.subscribe(date => {
            const value = this.slideshow.assignment.targetPublishDate ? new Date(this.slideshow.assignment.targetPublishDate) : null;
            this.targetDateControl.setValue(value);
        });
        this.slideshow.commentAdded.subscribe(comment => {
            if( this.notes ) {
                this.notes.comments.unshift(comment);
                this.notes.cdr.markForCheck();
            }
        });
    }
    introChange(e, type) {
        let slides = this.slideshow.slides;
        if( slides && slides.length == 0 ) {
            return;
        }
        if( type == 'intro' ) {
            slides[0].intro = e ? 1 : 0;
        }
        if( type == 'outro' && slides.length > 1 ) {
            let last = slides.length - 1;
            slides[last].outro = e ? 1 : 0;
        }
    }
    updateTeam(e, assignment) {
        this.teamService.updateAssignment(e, assignment);
        this.slideshow.updateMessages();
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/slideshow/tabs/details.component.ts